import { getSiteConfig } from '@config/sub-site/index'

export default ({ app }, inject) => {
  const siteConfig = getSiteConfig()
  inject('siteConfig', siteConfig.head)
  inject('siteNav', siteConfig.nav)
  inject('siteName', siteConfig.head.planName)
}